export default function FilePreviewContent({ url, alt }: { url?: string; alt: string }): React.ReactElement {
  return (
    <div className="flex flex-col z-10">
      <div className="relative h-32 flex flex-col overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-t from-white to-transparent" />
        {url && <img alt={alt} src={url} />}
      </div>
    </div>
  )
}
